/** import something here **/
import constants from 'src/config/const'
import jquery from 'jquery'
import VueOffline from 'vue-offline'
import VueClipboard from 'vue-clipboard2'
import VueAffix from 'vue-affix'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import { version } from '../../package.json'
import VueProgressiveImage from 'vue-progressive-image'
import helpers from 'src/helpers'
import { ACCESS_TOKEN, DEV_ECHO_PROXY, LOGGED_IN_USER_ID, LOGGED_IN_USER_NAME } from 'src/store/localStorageKeys'
import VueEcho from 'vue-echo'
import VueWait from 'vue-wait'
import VueWorker from 'vue-worker'
import globalComponents from 'src/config/global-components'
import { i18n } from './i18n'
import listItemFormGenerator from 'ibs-vue-list-items-form-generator'
import { get, post } from 'src/helpers/api'
import config from 'src/config'
import { VALIDATION_FAILED } from 'src/store/types'
import { mapActions, mapMutations, mapState } from 'vuex'
import { formatPriceDouble } from '../helpers/filters'

let path = require('path')

/** leave the export, even if you don't use it **/
export default ({ app, store, Vue }) => {
  Vue.config.productionTip = false
  /** Constant **/
  constants.install = function() {
    Object.defineProperty(Vue.prototype, '$const', {
      get() {
        return constants
      },
    })
  }
  Vue.use(constants)
  window.$ = jquery
  window.Vue = Vue

  // Make global
  window.il8n = i18n

  /** Filters **/
  Vue.filter('formatPriceDouble', function(value, fraction = 2) {
    return formatPriceDouble(value, fraction)
  })

  Vue.filter('uppercase', function(value) {
    if (!value) return ''
    return value.toUpperCase()
  })

  Vue.filter('stringToNumber', function(value, type = 'int', decimalPlace = 2) {
    value = value ? value : 0
    if (type === 'int') {
      return parseInt(value)
    } else if (type === 'float') {
      return parseFloat(value).toFixed(decimalPlace)
    } else {
      return 0
    }
  })

  Vue.prototype.$first = function(item, list) {
    return item === list[0]
  }
  Vue.prototype.$last = function(item, list) {
    return item === list[list.length - 1]
  }

  Vue.use(require('vue-shortkey'))
  Vue.use(VueOffline)
  Vue.use(VueClipboard)
  Vue.use(VueAffix)
  Vue.use(VueProgressiveImage, {
    placeholder: require('assets/' + 'no-image.png'),
  })
  Vue.use(VueWait)
  app.wait = new VueWait({
    useVuex: true,
  })
  Vue.use(VueWorker)
  Vue.use({
    install: function() {
      Object.defineProperty(Vue.prototype, '$customStore', {
        get() {
          return store
        },
      })
    },
  })
  if (process.env.LOG_SENTRY === 'true') {
    Raven.config(process.env.SENTRY_DSN, {
      release: version,
      dataCallback: function(data) {
        const stacktrace = data.exception && data.exception.values[0].stacktrace

        if (stacktrace && stacktrace.frames) {
          stacktrace.frames.forEach(function(frame) {
            if (frame.filename.startsWith('/') || frame.filename.startsWith('src')) {
              frame.filename = 'app:///' + path.basename(frame.filename)
            }
          })
        }

        return data
      },
    })
      .addPlugin(RavenVue, Vue)
      .install()
    Raven.setUserContext({
      name: helpers.decrypt(localStorage.getItem(LOGGED_IN_USER_NAME)),
      id: helpers.decrypt(localStorage.getItem(LOGGED_IN_USER_ID)),
    })
  }
  if (process.env.WEBSOCKET === 'true') {
    /**
     *
     * @type {string}
     */
    let echoProxy = localStorage.getItem(DEV_ECHO_PROXY)
    if (echoProxy == null) {
      echoProxy = process.env.ECHO_URL
    }
    window.io = require('socket.io-client')
    if (echoProxy) {
      Vue.use(VueEcho, {
        broadcaster: 'socket.io',
        host: echoProxy,
        auth: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
          },
        },
      })
    } else {
      console.error('_ENV_ECHO_URL_NOT_SPECIFIED')
    }
  }

  if (process.env.INIT_FRESH_WIDGET === 'true') {
    window.dispatchEvent(new Event('init.freshwidget'))
  }

  // Register global components
  globalComponents.forEach(component => {
    Vue.component(component.name, component)
  })

  // List items form generator
  Vue.use(listItemFormGenerator.plugin, store, {
    provider: 'quasar',
    axios: {
      methods: {
        get: get,
        post: post,
      },
    },
  })

  const appIcons = {
    'app:nav-itoken': `img:${config.app.menu.icons.itoken}`,
    'app:nav-prp': `img:${config.app.menu.icons.prp}`,
  }

  // Global Mixin
  Vue.mixin({
    created() {
      this.$q.iconMapFn = iconName => {
        const icon = appIcons[iconName]
        if (icon !== void 0) {
          return { icon: icon }
        }
      }
    },
    computed: {
      ...mapState({
        simplePagination: state => state.globalCMP.simplePagination,
        appSettings: state => state.globalCMP.appSettings,
        selectedFilters: state => state.globalCMP.selectedFilters,
      }),
      isDevelopmentMode() {
        return process.env.NODE_ENV === 'development' || process.env.IS_DEVELOPMENT === 'true'
      },
    },
    methods: {
      ...mapActions(['setArea']),
      ...mapMutations({
        openCloseModal: 'OPEN_CLOSE_MODAL_FORM',
        setFilterData: 'SET_FILTER_DATA',
        unSetFilterData: 'UNSET_FILTER_DATA',
        setNotification: 'SHOW_NOTIFICATION',
        setValidationFailed: VALIDATION_FAILED,
      }),
      /**
       * Global function to retrieve translations by short key
       *
       * Refer src/helpers/translator.js -> postTranslator for more info
       * @param key
       * @param params
       * @returns {VueI18n.TranslateResult}
       */
      $ts(key, params = {}) {
        return this.$t(this.$helpers.postTranslator(key), { ...params })
      },
    },
  })
}
